import { inject } from '@angular/core';
import { NavigationError } from '@angular/router';
import { ChunkRecoveryService } from './chunk-recovery.service';

/**
 * Router navigation-error handler (wired via `withNavigationErrorHandler`). When a
 * lazy route's chunk fails to load during navigation, hard-reloads to the intended
 * URL so the browser refetches index.html and the current build's chunks, landing
 * the user on the page they were navigating to. Non-chunk errors are left alone.
 * Runs in an injection context, so `inject()` is available.
 * @param navigationError the router navigation error
 */
export function chunkNavigationErrorHandler(navigationError: NavigationError): void {
  const recovery = inject(ChunkRecoveryService);
  if (recovery.isChunkLoadError(navigationError.error)) {
    recovery.recover(navigationError.url);
  }
}
